module.exports = __webpack_public_path__ + "img/1.b72a5b80.png";